<template>
	<form
		:class="[
			'styled-form',
			'styled-form--white-box',
			{'is-loading': isLoading}
		]"
		@submit.prevent="onSubmit">

		<div v-if="isLoading" class="styled-form__overlay">
			<div class="preloader"></div>
		</div>

		<global-message v-if="errors.global" :value="errors.global"></global-message>

		<div class="styled-form__header">
			<h2 class="styled-form__title">Update email address</h2>
			<h3 class="styled-form__subtitle">Please enter your new email address and also confirm it, below. Once you submit this form, it is important that you confirm your email address on the form that follows immediately or you will not be able to log back into your account.</h3>
		</div>

		<div class="styled-form__corset">

			<form-input
				v-model="data.newEmail"
				name="newEmail"
				label="New email address*"
				:error="errors.newEmail"
				class="to-lower-case"
			></form-input>

			<form-input
				v-model="data.newEmailConfirm"
				name="newEmailConfirm"
				label="Confirm new email address*"
				:error="errors.newEmailConfirm"
				class="to-lower-case"
			></form-input>

			<div class="text--center">
				<router-link
					class="btn btn--secondary"
					:disabled="isLoading"
					:to="{name: 'myAccount'}"
				>Cancel</router-link>
				<button class="btn" :disabled="isLoading">Update</button>
			</div>
		</div>
	</form>
</template>

<script>
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import FormInput from '../formFields/FormInput.vue';
	import isEmail from '../../helpers/isEmail';

	export default {
		components: {
			GlobalMessage,
			FormInput
		},
		props: {
			submit: {
				type: Function,
				required: true
			}
		},
		data() {
			return {
				isLoading: false,
				data: {
					newEmail: '',
					newEmailConfirm: ''
				},
				errors: {}
			}
		},
		methods: {
			onSubmit() {
				this.errors = this.validate(this.data);

				if (Object.keys(this.errors).length === 0) {
                    this.data.newEmail = this.data.newEmail.toLowerCase();
                    this.data.newEmailConfirm = this.data.newEmailConfirm.toLowerCase();
					this.isLoading = true;
					this.submit(this.data).catch(errors => {
						this.isLoading = false;
						this.errors = errors;
					});
				}
			},
			validate(data) {
				const errors = {};

				if (!data.newEmail.length) {
                    errors.newEmail = 'This field is required';
                } else if (!isEmail(data.newEmail)) {
                    errors.newEmail = 'Invalid email';
                }

                if (!data.newEmailConfirm.length) {
                    errors.newEmailConfirm = 'This field is required';
                } else if (!isEmail(data.newEmailConfirm)) {
                    errors.newEmailConfirm = 'Invalid email';
                } else if (data.newEmail !== data.newEmailConfirm) {
                    errors.newEmailConfirm = 'The email you entered does not match';
                }

				return errors;
			}
		}
	};
</script>
